export const getGitlabRedirectUrl = () => {
    const url = new URL(window.location.href);
    return `${url.origin}/integrations/gitlab/oauth`;
};

export const getGithubRedirectUrl = () => {
    const url = new URL(window.location.href);
    return `${url.origin}/integrations/github/oauth`;
};

export const getGithubAppRedirectUrl = () => {
    const url = new URL(window.location.href);
    return `${url.origin}/integrations/github-app/oauth`;
};

export const getSlackRedirectUrl = () => {
    const url = new URL(window.location.href);
    return `${url.origin}/integrations/slack/oauth`;
};

export const getJiraRedirectUrl = () => {
    const url = new URL(window.location.href);
    return `${url.origin}/integrations/jira/oauth`;
};

export const getNotionRedirectUrl = () => {
    const url = new URL(window.location.href);
    return `${url.origin}/integrations/notion/oauth`;
};
